import React, { Component } from 'react'

import CodeMirror from 'react-codemirror'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/addon/fold/foldcode'
import 'codemirror/addon/fold/foldgutter'
import 'codemirror/addon/fold/brace-fold'
import 'codemirror/addon/scroll/annotatescrollbar'
import 'codemirror/addon/search/search'
import 'codemirror/addon/search/searchcursor'
import 'codemirror/addon/search/jump-to-line'
import 'codemirror/addon/search/matchesonscrollbar'

class CodeBlockBrowser extends Component {
  constructor (props) {
    super(props)
    this.state = {update_count: 0, content: '{}'}
  }

  async componentDidMount () {
    const { to } = this.props
    const { update_count } = this.state
    const resp = await fetch(to).then((result) => result.json())
    this.setState({
      update_count: update_count+1,
      content: JSON.stringify(resp, null, 2)
    })
  }

  render () {
    const { to } = this.props
    const { content, update_count } = this.state

    return (
      <CodeMirror {...{value: content,
        key: to+update_count,  // Workaround to force new update
        className: 'codemirror-json',
        options: {
          mode: 'javascript',
          readOnly: true,
          lineWrapping: true,
          lineNumbers: true,
          foldGutter: true,
          lint: true,
          gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
          theme: 'ttcn',
          extraKeys: {
            'Ctrl-F': function(cm) {
              cm.execCommand('findPersistentNext')
            }
          }
        }
      }} />
    )
  }

}

export { CodeBlockBrowser }


// WEBPACK FOOTER //
// ./src/components/cards/CodeBlockBrowser.js